import type { ReactNode } from "react";
import { motion } from "motion/react";
import { usePrefersReducedMotion } from "@/hooks/use-prefers-reduced-motion";

/** Animated height wrapper for disclosure content. Children stay mounted while closed. */
export function CollapsibleContent({
  id,
  open,
  children,
}: {
  id: string;
  open: boolean;
  children: ReactNode;
}) {
  const reduceMotion = usePrefersReducedMotion();

  return (
    <motion.div
      id={id}
      initial={false}
      animate={{ height: open ? "auto" : 0, opacity: open ? 1 : 0 }}
      transition={{
        duration: reduceMotion ? 0 : 0.24,
        ease: "easeInOut",
      }}
      style={{ overflow: "hidden" }}
      aria-hidden={!open}
      inert={!open}
    >
      {children}
    </motion.div>
  );
}
